// import { ReactNode } from 'react';
// import { Form as _Form, FormProps } from 'antd';
import { Form } from 'antd';

// export default function Form(props: FormProps & { children: ReactNode }) {
//     return <_Form {...props}>{props.children}</_Form>;
// }

export default Form;
